/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SponsoredGuildCompetition,
    SponsoredGuildCompetitionFromJSON,
    SponsoredGuildCompetitionFromJSONTyped,
    SponsoredGuildCompetitionToJSON,
    SponsoredGuildCompetitionWithWinners,
    SponsoredGuildCompetitionWithWinnersFromJSON,
    SponsoredGuildCompetitionWithWinnersFromJSONTyped,
    SponsoredGuildCompetitionWithWinnersToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetCompetitionInfoResponse
 */
export interface GetCompetitionInfoResponse {
    /**
     * 
     * @type {SponsoredGuildCompetition}
     * @memberof GetCompetitionInfoResponse
     */
    currentCompetition?: SponsoredGuildCompetition;
    /**
     * 
     * @type {SponsoredGuildCompetitionWithWinners}
     * @memberof GetCompetitionInfoResponse
     */
    lastCompetition?: SponsoredGuildCompetitionWithWinners;
}

export function GetCompetitionInfoResponseFromJSON(json: any): GetCompetitionInfoResponse {
    return GetCompetitionInfoResponseFromJSONTyped(json, false);
}

export function GetCompetitionInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompetitionInfoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currentCompetition': !exists(json, 'currentCompetition') ? undefined : SponsoredGuildCompetitionFromJSON(json['currentCompetition']),
        'lastCompetition': !exists(json, 'lastCompetition') ? undefined : SponsoredGuildCompetitionWithWinnersFromJSON(json['lastCompetition']),
    };
}

export function GetCompetitionInfoResponseToJSON(value?: GetCompetitionInfoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currentCompetition': SponsoredGuildCompetitionToJSON(value.currentCompetition),
        'lastCompetition': SponsoredGuildCompetitionWithWinnersToJSON(value.lastCompetition),
    };
}


